import { Button, message, Modal } from "antd";
import "./style.scss";
import { usePostData } from "../../../Network/usePostData";
import { useState } from "react";
import OTPInput from "react-otp-input";
import { handleAction } from "../../../utils/requestStatus";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TextArea from "antd/es/input/TextArea";

type Props = {
  onCloseModal: () => void;
  refetch?: () => void;
  url: string;
  hasReason?: boolean;
};

export const ReasonNoteModal = ({
  onCloseModal,
  refetch,
  hasReason,
  url,
}: Props) => {
  const { t } = useTranslation();
  const [notesVal, setNoteVal] = useState<string>();
  const [loading, setLoading] = useState<boolean>();
  const { requestId } = useParams();

  const handleChangeStatus = async () => {
    setLoading(true);
    try {
      const body = {
        id: requestId,
        note: notesVal,
        ...(hasReason ? { reason: notesVal } : {}),
      };
      await handleAction(url, body);
      onCloseModal();
      setLoading(false);
      refetch?.();
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Modal className="status-reason-modal otp" open closable={false}>
      <h2>{hasReason ? t("requests.rejectReason") : t("requests.notes")}</h2>

      <div className="provider-details-details">
        <TextArea
          style={{ minHeight: "150px" }}
          name="reason"
          value={notesVal}
          onChange={(e) => setNoteVal(e.target.value)}
        />
      </div>

      <div className="modal-action">
        <Button
          disabled={!!!notesVal && hasReason}
          onClick={handleChangeStatus}
          loading={loading}
          type="primary"
        >
          {t("actions.submit")}
        </Button>

        <Button onClick={onCloseModal} type="default">
          {t("otpConfirmation.cancel")}
        </Button>
      </div>
    </Modal>
  );
};
